import type { DialoguePool } from '@/state/types';

export const L25_DIALOGUE: DialoguePool = {
  slowPlay: [
    'A vending machine. The 1970s thought this was the future. They were... optimistic.',
    'Progress costs. Everything costs. Even the concept of hope. Which is sold out.',
    'The machine hums. It expects currency. It doesn\'t know you\'re currency. We have that in common.',
  ],
  tokenLoss: [
    'You inserted a token. Into a machine I built. For a key I placed. This is a con.',
    'The machine accepted your token. I\'ve already spent it. Mentally.',
    'Another token, another nothing. You\'re subsidising my entertainment. Thank you. I think.',
  ],
  solution: [
    'You paid. For a key. To a door I made. That leads to another door I also made.',
    'The token drops. The key emerges. Your currency has been converted. Welcome to the economy.',
    'Progress: purchased. I accept your sacrifice. The machine accepts your metal. I accept your surrender.',
  ],
  spite: ['The key drops again. You\'ll make this transaction many times. I don\'t judge.'],
};